import { render, staticRenderFns } from "./VxCheckbox.vue?vue&type=template&id=e2e865fa&scoped=true"
import script from "./VxCheckbox.vue?vue&type=script&lang=js"
export * from "./VxCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VxCheckbox.vue?vue&type=style&index=0&id=e2e865fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e865fa",
  null
  
)

export default component.exports